import { render, staticRenderFns } from "./MeasurementSpecificationTemplates.vue?vue&type=template&id=1b120c8c"
import script from "./MeasurementSpecificationTemplates.vue?vue&type=script&lang=ts"
export * from "./MeasurementSpecificationTemplates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports